<script>
  import {createEventDispatcher} from 'svelte';
  import Card from './Card.svelte';

  export let item = {};
  
  const dispatch = createEventDispatcher();

  const handleDelete = (itemId) => {
    dispatch('delete-feedback', itemId);
  }
</script>

<div class="feedback--item">
  <Card>
    <div class="num-display">
      {item.rating}
    </div>
    <button class="close" on:click={() => handleDelete(item.id)}>X</button>
    <p class="text-display">
      {item.text}
    </p>
  </Card>
</div>

<style>
  .num-display {
    position: absolute;
    top: -10px;
    left: -10px;
    width: 50px;
    height: 50px;
    background-color: #ff6a95;
    color: #fff;
    border: 1px #eee solid;
    border-radius: 50%;
    padding: 10px;
    text-align: center;
    font-size: 19px;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    background: 0;
    border: 0;
  }
</style>